import React from "react";

import { Chip, ChipPropsColorOverrides } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import { TaskStatus as TaskStatusEnum } from "../../services/utils/status";

type StatusDetails = {
  color: OverridableStringUnion<
    "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ChipPropsColorOverrides
  >;
};

const STATUSES: { [key in TaskStatusEnum]: StatusDetails } = {
  [TaskStatusEnum.SUBMITTED]: { color: "default" },
  [TaskStatusEnum.PROGRESSING]: { color: "default" },
  [TaskStatusEnum.COMPLETE]: { color: "info" },
  [TaskStatusEnum.REGISTERED]: { color: "success" },
  [TaskStatusEnum.DEPRECATED]: { color: "default" },
  [TaskStatusEnum.CANCELED]: { color: "error" },
  [TaskStatusEnum.FAILED]: { color: "warning" },
  [TaskStatusEnum.ERROR]: { color: "error" },
  [TaskStatusEnum.INACTIVE]: { color: "dark" },
};

const TaskStatus: React.FC<{ status: TaskStatusEnum }> = ({ status }) => {
  const statusDetails = STATUSES[status];
  return (
    <Chip
      size="small"
      label={status}
      sx={{ lineHeight: "normal", minWidth: "110px", fontWeight: "bold" }}
      color={statusDetails?.color}
    />
  );
};

export default TaskStatus;
